import { apiUrl } from '../api/config'
import { setTimeout } from 'timers'
import auth from '../api/auth'
import axios from 'axios'
import router from '../router'

export const actions = {
  setDataLoaded ({ commit }, payload) {
    commit('setDataLoaded', payload)
  },
  setBreakpoint ({ commit }, payload) {
    commit('setBreakpoint', payload)
  },
  setWindowWidth ({ commit }, payload) {
    commit('setWindowWidth', payload)
  },
  setGifsLoaded ({ commit }) {
    commit('gifsLoaded')
  },
  toggleMainNav ({ commit }) {
    commit('toggleMainNav')
  },
  togglePageScrolls ({ commit }, payload) {
    commit('togglePageScrolls', payload)
  },
  closeMainNav ({ commit }) {
    commit('closeMainNav')
  },
  openPageNav ({ commit }) {
    commit('openPageNav')
  },
  togglePageNav ({ commit }) {
    commit('togglePageNav')
  },
  closePageNav ({ commit }) {
    commit('closePageNav')
  },
  incrementFontSize ({ commit }) {
    commit('incrementFontSize')
  },
  decrementFontSize ({ commit }) {
    commit('decrementFontSize')
  },
  toggleContrast ({ commit }) {
    commit('toggleContrast')
  },
  goToNextCategory ({ commit }) {
    commit('goToNextCategory')
  },
  goToPrevCategory ({ commit }) {
    commit('goToPrevCategory')
  },
  getMainResponse ({ commit }, payload) {
    commit('getMainResponse', payload)
  },
  setCurrentProductId ({ commit }, payload) {
    commit('setCurrentProductId', payload)
  },
  setApiAuthPath ({ commit, state }) {
    const lang = (state.mainData.settings.selectedTranslation ? state.mainData.settings.selectedTranslation : 'pl')
    state.apiAuthPath = apiUrl + 'authorized/' + lang + '/'
  },
  toggleLogin ({ commit, state }) {
    if (state.isLoggedIn && state.authToken) {
      commit('setNotLoggedIn')
      router.push({
        'name': 'login',
        'query': { 'logout': 'success' }
      })
    } else {
      router.push({ 'name': 'login' })
    }
  },
  toggleFullscreen ({ commit, state }) {
    const $el = document.documentElement

    if (state.isFullscreen && !state.iframeFullscreen) {
      if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msExitFullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      }
    } else {
      if ($el.requestFullscreen) {
        $el.requestFullscreen()
      } else if ($el.mozRequestFullScreen) {
        $el.mozRequestFullScreen()
      } else if ($el.webkitRequestFullscreen) {
        $el.webkitRequestFullscreen()
      } else if ($el.msRequestFullscreen) {
        $el.msRequestFullscreen()
      }
    }
    commit('setFullscreen')
  },
  toggleIframeFullscreen ({ commit, state }) {
    const $el = document.documentElement
    const $body = document.body || document.documentElement

    if (state.iframeFullscreen && !state.isFullscreen) {
      if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msExitFullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      }
    } else {
      if ($el.requestFullscreen) {
        $el.requestFullscreen()
      } else if ($el.mozRequestFullScreen) {
        $el.mozRequestFullScreen()
      } else if ($el.webkitRequestFullscreen) {
        $el.webkitRequestFullscreen()
      } else if ($el.msRequestFullscreen) {
        $el.msRequestFullscreen()
      }
    }
    commit('setIframeFullscreen')
    $body.setAttribute('data-fixed', (state.iframeFullscreen && state.isFullscreen ? 'fixed' : 'none'))
  },
  sendLoginForm ({ commit, state }, payload) {
    commit('loginErrors', false)

    auth.login(
      payload,
      (res) => {
        if (res.status === 'ok' && res.authKey) {
          commit('setLoggedIn', res)

          if (state.route && state.route.from && state.route.from.fullPath) {
            if (state.route.from.fullPath !== '/rejestracja') {
              router.push({ 'path': state.route.from.fullPath })
            } else {
              router.push({ 'path': '/' })
            }
          } else {
            router.push({ 'path': '/' })
          }
        } else {
          commit('loginErrors', res.status)
        }
      },
      (_err) => {
        commit('loginErrors', 404)
        console.log('Login respond error / ' + _err)
      }
    )
  },
  sendRegisterForm ({ commit, state }, payload) {
    let formData = new FormData()
    const lang = (state.mainData.settings.selectedTranslation ? state.mainData.settings.selectedTranslation : 'pl')

    commit('setDataLoaded', false)
    commit('registerErrors', null)

    if (payload) {
      for (var id in payload) {
        if (payload[id]) {
          formData.append(id, payload[id])
        }
      }
    }

    axios.post(`${apiUrl}${lang}/rejestracja`, formData)
      .then((res) => {
        if (res && res.status === 200) {
          if (res.data.ok) {
            setTimeout(() => {
              commit('setDataLoaded', true)
              commit('isRegistered', true)
              router.push({ 'name': 'register' })
            }, 1200)
          } else {
            commit('setDataLoaded', true)
            commit('registerErrors', res.data.errors)
          }
        } else {
          commit('setDataLoaded', true)
          commit('registerErrors', 404)
        }
      })
      .catch((err) => {
        setTimeout(() => {
          commit('setDataLoaded', true)
          commit('registerErrors', 404)
          console.error('Registration Form / ' + err)
        }, 1200)
      })
  },
  setNotRegistered ({ commit }) {
    commit('isRegistered', false)
  },
  sendNewsletterForm ({ commit, state }, payload) {
    let formData = new FormData()
    const lang = (state.mainData.settings.selectedTranslation ? state.mainData.settings.selectedTranslation : 'pl')

    if (payload) {
      formData.append('email', payload)
    }

    axios.post(`${apiUrl}${lang}/newsletterForm`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((res) => {
      if (res.data && res.data.msg === 'ok') {
        commit('setNewsletterSignin')
      } else {
        commit('setNewsletterErrors', res.data.msg)
      }
    }).catch((err) => {
      console.error('Newsletter Form / ' + err)
      commit('setNewsletterErrors', 404)
    }) // END axios.post();
  },
  clearNewsletterErrors ({ commit, state }, payload) {
    commit('clearNewsletterErrors')
  },
  clipboardActions ({ commit, state }) {
    commit('addToClipboard', state.route.params.id)
  },
  setActiveFilters ({ commit }, payload) {
    commit('setActiveFilters', payload)
  },
  resetActiveFilters ({ commit }, payload) {
    commit('setActiveFilters', [])
    commit('setActiveSearch', '')
  },
  setActiveSearch ({ commit }, payload) {
    commit('setActiveSearch', payload)
  },
  setActiveListItem ({ commit }, payload) {
    commit('setActiveListItem', payload)
  },
  resetActiveSearch ({ commit }, payload) {
    commit('setActiveSearch', '')
  }
}
